import logger from "@utils/logger";

// __Host- names need Secure, Path=/ and no Domain; Lax stops cross-site iframes from setting them
const ATTRIBUTES = "Path=/; Secure; SameSite=Lax";

export const setCookie = (name: string, value: string, maxAgeSeconds: number): void => {
  try {
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAgeSeconds}; ${ATTRIBUTES}`;
  } catch (error) {
    logger._console.error(error);
  }
};

export const getCookie = (name: string): string | undefined => {
  try {
    const entry = document.cookie.split("; ").find((pair) => pair.startsWith(`${name}=`));
    return entry === undefined ? undefined : decodeURIComponent(entry.slice(name.length + 1));
  } catch (error) {
    logger._console.error(error);
    return undefined;
  }
};

export const deleteCookie = (name: string): void => setCookie(name, "", 0);
